/**
 * Possible transformation options for the @Exclude decorator.
 */
export interface ExcludeOptions {
  /**
   * Expose this property only when transforming from plain to class instance.
   */
  toClassOnly?: boolean;

  /**
   * Expose this property only when transforming from class instance to plain object.
   */
  toPlainOnly?: boolean;
}
